// extracted by mini-css-extract-plugin
module.exports = {"quick-link-item":"quick-link-item__7Pzvd"};